import React from "react";

import classNames from "classnames";
import { useNavigate } from "react-router-dom";

import { ParticipantTypes } from "@api/graphql";
import { useIsAuthUserAllowed } from "@components/permission_control/ProtectedComponent";
import { Role } from "@roles";

import { ROUTES } from "../../routes";

import styles from "./ParticipantName.module.scss";

interface ParticipantNameProps {
  name: string | number | boolean;
  // participantId could be undefined if no associated artist_id in tables
  // in this case, it will be shown as non-clickable text
  participantId?: number;
  defaultTab?: "AccountDetails" | "AccountRelationships";
  disableClick?: boolean;
  participantType?: ParticipantTypes[];
  companyName?: string;
}

const ParticipantName: React.FC<ParticipantNameProps> = ({
  name,
  participantId,
  defaultTab = "AccountRelationships",
  disableClick,
  participantType,
  companyName,
}) => {
  const navigate = useNavigate();

  const redirectParticipant = (participantId: number) => {
    const profilePath =
      defaultTab === "AccountRelationships"
        ? ROUTES.Dashboard.Profile[defaultTab].buildPath({ participantId })
        : ROUTES.Dashboard.Profile.buildPath({ participantId });
    navigate(profilePath);
  };

  const isVAAdmin = useIsAuthUserAllowed([Role.VisualArtistAdmin]);
  const isMemberServices = useIsAuthUserAllowed([Role.MemberServices]);
  const isDataUser = useIsAuthUserAllowed([Role.Data]);
  const isInternalUser = isVAAdmin || isMemberServices || isDataUser;
  const isClickable = isInternalUser && participantId && !disableClick;
  const handleClick = () => {
    if (isClickable) {
      redirectParticipant(participantId);
    }
  };
  const isCollaborationAccount = participantType?.includes(ParticipantTypes.COLLABORATION);

  return (
    <span
      className={classNames({ [styles["participant-linked"]]: isClickable })}
      onClick={isInternalUser ? handleClick : undefined}
      role={isInternalUser ? "button" : undefined}
    >
      {isCollaborationAccount ? companyName : name}
    </span>
  );
};

export default ParticipantName;
